import React, { useEffect } from "react";
import { withRouter, useParams } from "react-router-dom";
import { connect } from "react-redux";

import styles from "./DownloadAffiliate.module.scss";

import { downloadAffiliateFileAction } from "store/actions/Actions";

const DownloadAffiliate = (props) => {
    const { downloadAffiliateFileAction } = props;

    let { hash } = useParams();

    useEffect(() => {
        if (hash) {
            downloadAffiliateFileAction({ hash });
        }
    }, [hash]);

    return (
        <div className={styles.error}>
        <p>Your download is ready!</p>
    </div>
    );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
    downloadAffiliateFileAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(DownloadAffiliate));
